import type { CartItem } from '../types'
import type { CreateOrderPayload } from './api'

/**
 * Phase 7B-1 — order submission helpers for the client checkout flow.
 *
 * The backend is authoritative for all money and order identity, so the
 * payload carries ONLY outlet_name + product_id / purchase_type / quantity.
 * Cart preview prices/names/totals are display-only and never sent.
 */

/** Build the minimal POST /api/orders payload from cart state. */
export function buildOrderPayload(outletName: string, cart: CartItem[]): CreateOrderPayload {
  return {
    outlet_name: outletName.trim(),
    items: cart.map((item) => ({
      product_id: item.productId,
      purchase_type: item.purchaseType,
      quantity: item.quantity,
    })),
  }
}

/**
 * Map a submission failure to a user-facing message.
 * Specific backend messages are preserved; anything else (including network
 * failures) falls back to a clear Indonesian message.
 */
export function getOrderErrorMessage(err: unknown): string {
  if (err instanceof TypeError) {
    return 'Tidak dapat terhubung ke server. Periksa koneksi internet Anda, lalu coba lagi.'
  }
  if (err instanceof Error) {
    const message = err.message?.trim()
    if (message) {
      return message
    }
  }
  return 'Gagal menyimpan pesanan. Silakan coba lagi.'
}
